import { getCustomStyles } from "Config/Config";
import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const BussinessAccordion = ({
  sectorList = [],
  sectorValue = null,
  sectorSelectionHandler,
  billing = "",
  setbilling,
  countOfEmployees = "",
  setcountOfEmployees,
  lastTransaction = "",
  setlastTransaction,
  transactionModule = "",
  settransactionModule,
  transactionAmount = "",
  settransactionAmount,
  transactionDate = "",
  settransactionDate,
  transactionElement = "",
  settransactionElement,
}) => {
  const { t } = useTranslation();

  return (
    <div className="accordion-item bg-transparent border-0">
      <h3 className="accordion-header">
        <button
          className="accordion-button bg-transparent p-0 shadow-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseNine"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseNine"
        >
          {t("Business Information")}
        </button>
      </h3>

      <div
        id="panelsStayOpen-collapseNine"
        className="accordion-collapse collapse show"
      >
        <div className="accordion-body p-0 pt-4">
          {/* Sector (full row) */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Sector")}
            </label>
            <Select
              isMulti
              className="w-100"
              placeholder={t("Select sectors")}
              options={sectorList}
              value={sectorValue}
              onChange={(val) => {
                sectorSelectionHandler(val);
              }}
              styles={getCustomStyles()}
            />
          </div>

          {/* Billing & Employees (side by side) */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Billing")}
                </label>
                <input
                  type="number"
                  min={0}
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Add billing")}
                  value={billing}
                  onChange={(e) => {
                    if (e.target.value >= 0) {
                      setbilling(e.target.value);
                    }
                  }}
                />
              </div>

              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Employees")}
                </label>
                <input
                  type="number"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  placeholder={t("Add employees numbers")}
                  value={countOfEmployees}
                  onChange={(e) => {
                    if (e.target.value >= 0) {
                      setcountOfEmployees(e.target.value);
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* Last Transaction & Transaction Module (side by side) */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Last transaction")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  value={lastTransaction}
                  onChange={(e) => setlastTransaction(e.target.value)}
                />
              </div>

              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Transaction Module")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  value={transactionModule}
                  onChange={(e) => settransactionModule(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Transaction Amount & Transaction Date (side by side) */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <div className="row">
              <div className="col-lg-6 mb-3 mb-lg-0">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Transaction Amount")}
                </label>
                <input
                  type="text"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  value={transactionAmount}
                  onChange={(e) => settransactionAmount(e.target.value)}
                />
              </div>

              <div className="col-lg-6">
                <label className="d-block fs-sm fw-semibold mb-2">
                  {t("Transaction Date")}
                </label>
                <input
                  type="date"
                  className="form-control fs-sm border border-gray-300 shadow-none"
                  value={transactionDate}
                  onChange={(e) => settransactionDate(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Transaction Element (full row) */}
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label className="d-block fs-sm fw-semibold mb-2">
              {t("Transaction Element")}
            </label>
            <input
              type="text"
              className="form-control fs-sm border border-gray-300 shadow-none"
              placeholder={t("Transaction Element")}
              value={transactionElement}
              onChange={(e) => {
                settransactionElement(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BussinessAccordion;
